import * as actions from '../actions/actor-actions';

// reducer
export default function actors(state = {}, action = {}) {
  switch (action.type) {
    case actions.ACTOR_SUCCESS:
      return Object.assign({}, state, {
        [action.fetchedActor.id]: action.fetchedActor
      });

    default:
      return state;
  }
}

// selectors
export const getActor = (actorId, state) => state.actors[actorId];
export const getFiltersForActor = (actorId, state) => {
  return {
    ...state.filters,
    fields: {
      ...state.filters.fields,
      actor: {
        id: 'actor',
        label: 'Actor',
        value: { label: '', value: actorId }
      }
    }
  };
};
